module.exports = __webpack_public_path__ + "static/media/intro-mobile.28d8a9a8.jpg";